module.exports = __webpack_public_path__ + "static/media/Search.4b00e20a.svg";